import React from 'react';
import { Paper, Table, TableBody, TableHead, TableCell, TableSortLabel, TablePagination, TableRow, Checkbox } from '@material-ui/core';
import { isMobile } from 'react-device-detect';
import { useTableStyle } from '../../utils_v2/materialStyles';
export default function TableListComp({bulkOperation=false, bulkFlag, heads, noRecord, data, sort='', sort_by='', pagination={}, onChangePage, onChangeRowsPerPage, createSortHandler, classNames, toggleBulkOps,style,panelClassName}){
  const classes = useTableStyle();
  return(
    <div style={{clear: 'both', width: '100%'}}>
      <Paper >
        <div style={style} className={classes.tableWrapper + (panelClassName ? ' ' + panelClassName : '')}>
          <Table
            className={classes.table + ' mui-table-format ' + classNames}
            aria-labelledby="tableTitle"
            stickyHeader={true}
            size='medium'
          >
            <TableHead className="mui-table">
              <TableRow>
                { bulkOperation ?
                  <TableCell style={bulkOperation ? { position: "sticky", left: 0, zIndex: 20, backgroundColor: "#B5BEDB" }:{}} >
                    <Checkbox
                      size="small"
                      checked={bulkFlag}
                      onChange={(e) => toggleBulkOps(e.target.checked)}
                      name="bulk_operation"
                      color="primary"
                    />
                  </TableCell>:null
                }
                {heads.map((row, index) =>
                  <TableCell
                    key={index}
                    align={row.actionCell ? 'right':'left'}
                    padding={'default'}
                    sortDirection={sort === row.id ? (sort_by ? sort_by:'asc') : false}
                    style={ row.sticky ? { position: "sticky", left: bulkOperation ? 55 : 0, backgroundColor: "#B5BEDB", zIndex: 15 } : {} }
                  >
                    {row.sortOption && noRecord === null ?
                      <TableSortLabel
                        active={sort === row.id}
                        direction={sort_by && sort === row.id ? sort_by:'asc'}
                        onClick={() => createSortHandler(row.id)}
                      >
                        <div style={{ minWidth: row.width ? row.width :'', maxWidth: row.maxWidth ? row.maxWidth :''}}>{row.label}</div>
                      </TableSortLabel>:<span><div style={{ minWidth: row.width ? row.width :'', maxWidth: row.maxWidth ? row.maxWidth :''}}>{row.label}</div></span>
                    }
                  </TableCell>
                )}
              </TableRow>
            </TableHead>
            <TableBody>
              { noRecord ? <TableRow><TableCell colSpan={bulkOperation ? heads.length+1:heads.length} align="center">{noRecord}</TableCell></TableRow>:data}
            </TableBody>
          </Table>
        </div>
        { Object.keys(pagination).length && pagination.total > 0 ?
            <TablePagination
              rowsPerPageOptions={[10, 20, 50]}
              component="div"
              count={pagination.total}
              rowsPerPage={pagination.per_page}
              page={pagination.page - 1}
              backIconButtonProps={{'aria-label': 'previous page'}}
              nextIconButtonProps={{'aria-label': 'next page'}}
              onChangePage={onChangePage}
              onChangeRowsPerPage={onChangeRowsPerPage}
            />:null
        }
      </Paper>
    </div>
  )
}
